import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Dutch translations
import common from "../locales/nl/common.json";
import errors from "../locales/nl/errors.json";
import toasts from "../locales/nl/toasts.json";
import auth from "../locales/nl/auth.json";
import chat from "../locales/nl/chat.json";
import gebreken from "../locales/nl/gebreken.json";

i18n.use(initReactI18next).init({
  lng: "nl",
  fallbackLng: "nl",
  supportedLngs: ["nl"],
  defaultNS: "common",
  ns: ["common", "chat", "auth", "gebreken", "errors", "toasts"],
  interpolation: {
    escapeValue: false, // React already escapes
  },
  resources: {
    nl: {
      common,
      chat,
      auth,
      gebreken,
      errors,
      toasts,
    },
  },
});
